<template>
    <views class="drawer">
        <views class="drawer-input" @click="toggle">
            <views v-if="originData.length > 0">
                <views
                    v-for="(item, index) in originData.slice(0, 3)"
                    :key="index"
                    class="tag">
                    {{ item }}
                </views>
                <views v-if="originData.length > 3" class="tag">...</views>
            </views>
            <views v-else>{{ value.tip }}</views>
        </views>
        <views v-if="visible" class="drawer-modal">
            <views class="drawer-modal__body" @click="stop">
                <views class="drawer-modal__body-head">
                    <views class="btn" @click="cancel">取消</views>
                    <views class="btn" @click="ok">确定</views>
                </views>
                <views class="drawer-modal__body-content">
                    <views
                        v-for="(item, index) in listData"
                        :key="index"
                        :class="{'active': item.active}"
                        class="list"
                        @click="select(item)">
                        {{ item.name }}
                    </views>
                </views>
            </views>
        </views>
    </views>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            visible: false,
            originData: [], // 点击弹窗层的数据
            activeData: [] // 实际选择数据
        }
    },
    computed: {
        listData() {
            const arr = []
            this.value.choose_value.map((item) => {
                arr.push({
                    name: item,
                    active: this.activeData.includes(item)
                })
            })
            return arr
        },
        defaultValue() {
            const value = this.value.value || this.value.default_value
            if (value) {
                return value.split(',')
            } else {
                return []
            }
        }
    },
    created() {
        this.originData = this.defaultValue
    },
    methods: {
        toggle() {
            this.visible = !this.visible
            console.log()
            // 弹框打开，重新赋值
            if (this.visible) {
                this.originData = this.defaultValue
                this.activeData = [...this.originData]
            }
        },
        stop() {
            event.stopPropagation()
        },
        ok() {
            this.$emit('ok', {
                ...this.value,
                value: this.activeData.join(',')
            })
            this.originData = [...this.activeData]
            this.toggle()
        },
        cancel() {
            this.toggle()
        },
        select(item) {
            const index = this.activeData.indexOf(item.name)
            if (this.activeData.includes(item.name)) {
                this.activeData.splice(index, 1)
            } else {
                this.activeData.push(item.name)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
